module.exports = __webpack_public_path__ + "img/Communication.6be07843.svg";